<template>
  <div class="user-actions-container">
    <v-btn 
      icon="mdi-account"
      @click="open = !open"
      >
    </v-btn>
    <v-card class="menu" v-if="open" variant="outlined tonal elevated">
      <v-card-title>
        user
      </v-card-title>
      <v-divider />
      <v-card-text>
        <span v-if="user && user.email">
          {{ user.email }}
        </span>
        <span v-else-if="user">
          not logged in
        </span>
        <span v-else>
          loading
          <v-progress-linear color="yellow-darken-2" indeterminate></v-progress-linear>
        </span>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="signOut()">sign out</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { onAuthStateChanged, signOut } from 'firebase/auth';

export default {
  name: 'UserActions',
  data () {
    return {
      open: false,
      user: null
    }
  },
  methods: {
    signOut () {
      signOut(this.$auth);
    }
  },
  mounted () {
    onAuthStateChanged(this.$auth, user => {
      this.user = user;
    });
  }
}
</script>

<style scoped>
.user-actions-container {
  position: absolute;
  top: 1em;
  right: 1em;
}

.menu {
  position: absolute;
  right: 0px;
  margin-top: 1em;

  width: 10em;

  background-color: white;
}
</style>